import React, {ReactElement} from "react";
import {SidebarContext, SidebarRenderer} from "../types";
import {LabelsSidebarView} from "./LabelsSidebarView";

export class LabelsSidebarRenderer implements SidebarRenderer {

  renderToolbar(): ReactElement {
    return null;
  }

  renderContent(context?: SidebarContext): ReactElement {
    if (!context.case_) return null;
    return <LabelsSidebarView
      case_={context.case_}
      elements={context.elements || []}
      selectedIds={context.selectedElementIds || []}
      onSelect={context.onSelectElement}
      onDelete={context.onDeleteElement}
    />;
  }
}
